import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn.ts";

export type InfoProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
  value: React.ReactNode;
};

export function Info({ label, value, className, ...props }: InfoProps) {
  return (
    <div className={cn(className)} {...props}>
      <div className="text-[10.5px] font-semibold uppercase tracking-wide text-[var(--sf-text-muted)]">
        {label}
      </div>
      <div className="mt-0.5 text-[13px] text-[var(--sf-text)]">{value}</div>
    </div>
  );
}
